/**
 * This function does not fetch anything, but it's required to prevent conditional hook rendering
 */
export const useDefaultFetch = () => ({
  data: [],
  status: 'success',
  fetchNextPage: () => void 0,
  hasNextPage: false
});